import { getLaunchpadLaneIndicators } from 'constants/launchpadLaneIndicators';
import { getLaunchpadLanes } from 'constants/launchpadLanes';

import LaunchpadLane from '../LaunchpadLane/LaunchpadLane';
import LaunchpadStageCard from '../LaunchpadStageCard/LaunchpadStageCard';

import type ILaunchpadLanesProps from './interfaces/ILaunchpadLanesProps';

import styles from './sass/LaunchpadLanes.module.scss';

function LaunchpadLanes({ hasActiveVcm, selectedMapId, onDiscoverClick }: ILaunchpadLanesProps) {
  const lanes = getLaunchpadLanes();

  return (
    <div className={styles.root}>
      {lanes.map((lane) => {
        const indicators = getLaunchpadLaneIndicators(lane.id);

        return (
          <LaunchpadLane key={lane.id} lane={lane}>
            {lane.tiles.map((tile) => {
              const indicator = indicators.find((item) => item.id === tile.id);
              if (!indicator) {
                return null;
              }

              return (
                <LaunchpadStageCard
                  key={tile.id}
                  laneId={lane.id}
                  tile={tile}
                  indicator={indicator}
                  hasActiveVcm={hasActiveVcm}
                  selectedMapId={selectedMapId}
                  onDiscoverClick={onDiscoverClick}
                />
              );
            })}
          </LaunchpadLane>
        );
      })}
    </div>
  );
}

export default LaunchpadLanes;
